import { z } from 'zod';

export const OutcomeEvidenceInput = z.object({
  evidence_kind: z.enum([
    'photo',
    'receipt',
    'provider_confirmation',
    'worker_attestation',
    'owner_attestation',
    'system_record',
  ]),
  source_ref: z.string().min(1).max(300),
  captured_at: z.string().datetime({ offset: true }),
  validates_criterion: z.string().min(1).max(120),
  assessment: z.enum(['unreviewed', 'supports', 'contradicts', 'insufficient']),
  privacy_class: z.enum(['standard', 'sensitive']),
});
export const EvaluateOutcomeRequest = z.object({
  criteria: z
    .array(
      z.object({
        code: z
          .string()
          .regex(/^[a-z0-9_]+$/)
          .max(120),
        satisfied: z.boolean(),
        rationale: z.string().min(1).max(500),
      }),
    )
    .min(1)
    .max(20),
  evidence: z.array(OutcomeEvidenceInput).max(30),
});
export const AssertOutcomeRequest = z.object({
  decision: z.enum(['accept_satisfied', 'accept_exception', 'return_to_active']),
  expected_revision: z.number().int().positive(),
  rationale: z.string().min(2).max(1000),
  accepted_exception_codes: z.array(z.string().max(120)).max(20).default([]),
});
export const RecordOutcomeCorrectionRequest = z.object({
  correction_class: z.enum([
    'intent',
    'context',
    'chain',
    'action',
    'rendering',
    'evidence',
    'outcome',
    'external_cause',
  ]),
  decision_id: z.string().max(40).optional(),
  action_id: z.string().max(40).optional(),
  reason: z.string().min(2).max(1000),
  preventable: z.boolean(),
  future_behavior: z.enum([
    'none',
    'propose_context_candidate',
    'propose_rule_candidate',
    'adjust_rendering_candidate',
    'require_future_clarification',
  ]),
});
export type EvaluateOutcomeInput = z.infer<typeof EvaluateOutcomeRequest>;
export type AssertOutcomeInput = z.infer<typeof AssertOutcomeRequest>;
export type RecordOutcomeCorrectionInput = z.infer<typeof RecordOutcomeCorrectionRequest>;
